import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { BookOpen } from "lucide-react";

const StoryOfTheWeek = () => {
  const [story, setStory] = useState<any>(null);

  useEffect(() => {
    supabase
      .from("weekly_story")
      .select("*")
      .eq("is_active", true)
      .order("week_start", { ascending: false })
      .limit(1)
      .maybeSingle()
      .then(({ data }) => setStory(data));
  }, []);

  if (!story) return null;

  return (
    <section className="container mx-auto px-4 py-3">
      <a
        href={story.story_link}
        className="block bg-white border-2 border-cyan-200 rounded-3xl overflow-hidden shadow hover:shadow-lg transition"
      >
        <div className="flex flex-col md:flex-row">
          {story.cover_image_url && (
            <img
              src={story.cover_image_url}
              alt={story.title}
              className="w-full md:w-56 h-40 md:h-auto object-cover"
              loading="lazy"
            />
          )}
          <div className="p-4 flex-1">
            <div className="flex items-center gap-2 text-cyan-700 text-xs font-bold uppercase">
              <BookOpen className="w-4 h-4" /> New Story This Week
            </div>
            <h3 className="text-xl font-extrabold text-gray-900 mt-1">{story.title}</h3>
            {story.description && (
              <p className="text-sm text-gray-700 mt-1">{story.description}</p>
            )}
            <span className="inline-block mt-3 bg-amber-400 text-white font-bold px-4 py-2 rounded-full">
              Read Now
            </span>
          </div>
        </div>
      </a>
    </section>
  );
};

export default StoryOfTheWeek;
